import { takeLatest, put, call, fork } from "redux-saga/effects";
import { CaseService } from "services";

import {
    fetchedRetailerRiskControlDetail,
    failedFetchRetailerRiskControlDetail,
    updatedRetailerRiskControlDetail,
    failedUpdateRetailerRiskControlDetail
} from "store/actions";
import { RETAILER_RISK_CONTROL_ACTIONS } from "constants";
import { message } from "antd";


function* updateRetailerRiskControlDetail({ payload: { caseId , retailerRiskControlDetail, method} }) {
   try {
        const { data, error } = yield call(
            CaseService.updateRetailerRiskControlDetail,
            retailerRiskControlDetail,
            method
        );
        if (!error) {
            message.success("Data Updated Successfully.")
            yield put(updatedRetailerRiskControlDetail(caseId, data));
        } else {
            yield put(failedUpdateRetailerRiskControlDetail(caseId, error));
        }
    } catch (error) {
        message.error(error?.non_field_errors && error?.non_field_errors[0] || "Something went wrong");
        yield put(failedUpdateRetailerRiskControlDetail(caseId, error));
    }
}

function* fetchRetailerRiskControlDetail({ payload: { caseId, company_id } }) {
    try {
        const { data, error } = yield call(CaseService.getRetailerRiskControlDetail, caseId, company_id);
        if (!error && data) {
            yield put(fetchedRetailerRiskControlDetail(caseId, data));
        } else {
            yield put(failedFetchRetailerRiskControlDetail(caseId, error));
        }
    }catch (error) {
        yield put(failedFetchRetailerRiskControlDetail(caseId, error));
    }
}




export default fork(function*() {
    yield takeLatest(RETAILER_RISK_CONTROL_ACTIONS.FETCH_RETAILER_RISK_CONTROL_DETAIL, fetchRetailerRiskControlDetail);
    yield takeLatest(RETAILER_RISK_CONTROL_ACTIONS.UPDATE_RETAILER_RISK_CONTROL_DETAIL,updateRetailerRiskControlDetail)
});
